__turbopack_context__.v({
  "description": "IconArticleBanner-module-scss-module__-BCYfG__description",
  "iconArticleBanner": "IconArticleBanner-module-scss-module__-BCYfG__iconArticleBanner",
  "iconArticleBannerSection": "IconArticleBanner-module-scss-module__-BCYfG__iconArticleBannerSection",
  "iconContainer": "IconArticleBanner-module-scss-module__-BCYfG__iconContainer",
});
